module.exports = __webpack_public_path__ + "static/media/iep-ui-design01-thumb.d3eb4e6c.png";